import React, { useState } from "react";

import { Text, TextInput, StyleSheet, View } from "react-native";
import { MaskedTextInput } from "react-native-mask-text";

export default function MaskedInput({
  value,
  label,
  mask,
  keyboardType,
  onValueChange,
  error,
}) {
  return (
    <>
      <View style={styles.inputContainer}>
        <Text style={styles.label}>{label}</Text>
        <MaskedTextInput
          mask={mask}
          value={value}
          keyboardType={keyboardType}
          onChangeText={(text, rawText) => {
            onValueChange(text);
          }}
          style={styles.input}
        />
        {error ? <Text style={styles.error}>{error}</Text> : null}
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  label: {
    fontSize: 16,
    marginBottom: 6,
    marginTop: 5,
  },
  input: {
    outlineStyle: "none",
    width: "100%",
    padding: "10px",
    borderWidth: "1px",
    borderColor: "#ccc",
    borderRadius: "4px",
    marginBottom: 10,
    backgroundColor: "#ffffff"
  },
  inputContainer: {
    flex: 1
  },
  error: {
    marginTop: -10,
    fontSize: 13,
    fontStyle: "italic",
    color: "red",
  },
});
